import { render, staticRenderFns } from "./L2.vue?vue&type=template&id=790ed165&"
import script from "./L2.vue?vue&type=script&lang=js&"
export * from "./L2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports